export const StorageService = {
    getLocal,
    setLocal,
    deleteLocal,
    getSession,
    setSession,
    deleteSession,
};

function getLocal<T>(key: string, defaultValue?: T): T {
    const raw = localStorage.getItem(key);
    if (raw === null) {
        return defaultValue as T;
    }
    try {
        const parsed = JSON.parse(raw);
        if (
            parsed !== null &&
            typeof parsed === 'object' &&
            !Array.isArray(parsed) &&
            Object.keys(parsed).length === 1 &&
            'data' in parsed
        ) {
            return parsed.data as T;
        }
        return parsed as T;
    } catch {
        return defaultValue as T;
    }
}

function setLocal(key: string, data: string | number | object): void {
    localStorage.setItem(key, JSON.stringify(data));
}

function deleteLocal(key: string): void {
    localStorage.removeItem(key);
}

function setSession(key: string, data: string) {
    sessionStorage.setItem(key, data);
}

function getSession<T = string>(key: string, defaultValue?: T) {
    return sessionStorage.getItem(key) || defaultValue;
}

function deleteSession(key: string) {
    sessionStorage.removeItem(key);
}
